import { concatValuesBy, defaultTxt } from '@miq/utils';
import { ReportRecord } from '../../../models/report.model';
import { TemplateFieldsDisplayFn } from '../../../models/template.model';
import { sortAttributesByFieldId } from '../utils/argument-sorting';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../utils/dynamic-data-retrievers';

export const displayFnMap: TemplateFieldsDisplayFn = {
  2: { displayFn: displayFnWrapper },
  3: { displayFn: displayFnWrapper },
  4: { displayFn: displayFnWrapper },
  5: { displayFn: displayFnWrapper },
  6: { displayFn: displayFnWrapper },
  7: { displayFn: displayFnWrapper },
  8: { displayFn: displayFnWrapper },
  9: { displayFn: displayFnWrapper },
  10: { displayFn: displayFnWrapper },
  11: { displayFn: displayFnWrapper },
  12: { displayFn: displayFnWrapper },
  13: { displayFn: displayFnWrapper },
  14: { displayFn: displayFnWrapper },
  15: { displayFn: displayFnWrapper },
  16: { displayFn: displayFnWrapper },
  17: { displayFn: displayFnWrapper },
  18: { displayFn: displayFnWrapper },
  25: {
    displayFn: (record: ReportRecord, _, ...args) => {
      const values = args.map(arg => mapAndFormatDynamicValue(record, arg));
      return concatValuesBy(', ', ...values);
    },
  },
  27: {
    displayFn: (record: ReportRecord, options, ...args) => {
      const finalArgs = sortAttributesByFieldId(options.locale, args, 27);
      const values = finalArgs.map(arg => mapAndFormatDynamicValue(record, arg));
      return concatValuesBy(', ', ...values);
    },
  },
  49: {
    displayFn: (record: ReportRecord, _, arg1, arg2) => {
      const values = concatValuesBy(
        defaultTxt,
        mapAndFormatDynamicValue(record, arg1),
        mapAndFormatDynamicValue(record, arg2)
      );
      return values;
    },
  },
};
